<template>
  <div
    class="import-wrapper"
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0)">
    <div v-show="tableData.length === 0" class="empty-view flex flex-col flex-center">
      <el-upload
        v-model="file"
        ref="upload"
        class="avatar-uploader"
        :auto-upload="false"
        action=""
        accept=".xlsx,.xls"
        :limit="1"
        :show-file-list="false"
        :on-change="beforeUpload">
        <div class="upload-btn flex flex-center justify-center">
          <img class="icon" src="../../assets/images/flow/upload.png" alt="上传"/>
          <span>上传文件</span>
        </div>
      </el-upload>
      <p class="desc">推荐使用我们提供的模板文件，<a class="link" :href="templateHref" :download="downloadName">下载模板文件</a></p>
      <div>
        <p class="desc" style="font-weight: bold;">模板说明（导入前必读）</p>
        <p class="desc">1、顾客信息可自行增减编辑（以下为举例）</p>
        <p class="desc">2、除金额以外的缴费人员信息，请勿重复，以免无法匹配正确金额；</p>
        <p class="desc">3、倒数第一项为“金额”即应付金额，且列名固定为【金额】，单位为元，金额格式参考模板，最小输入金额为0.01；</p>
        <p class="desc">4、导入时请保留本行，从第2行开始编辑，否则将导入失败。</p>
      </div>
    </div>
    <div v-show="tableData.length" class="table-view">
      <div class="table-top flex flex-center space-between">
        <div class="left">
          <p class="sub-title">收款信息</p>
          <div class="desc-view flex flex-center">
            <img class="ok-icon" src="../../assets/images/flow/ok.png" alt="上传"/>
            <p class="desc mb0">
              导入成功 导入
              <span class="green">{{ tableData.length }}</span>条
            </p>
          </div>
        </div>
        <el-button class="clear-btn" @click="handleReset">清除并重新导入</el-button>
      </div>
      <el-table :data="tableData" border style="width: 100%;" height="700">
        <el-table-column
          v-for="(item, index) in tableCols"
          :key="index"
          :prop="item.prop"
          :label="item.label"/>
        <el-table-column fixed="right">
          <template slot="header" slot-scope="scope">
            <el-button @click="handleEditHeader(scope)" type="text" class="edit-btn">编辑</el-button>
          </template>
          <template slot-scope="scope">
            <el-button @click="handleEditData(scope.row, scope.$index)" type="text" class="edit-btn">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      :visible="showDialog"
      width="600px"
      top="5vh"
      class="dialog-wrap"
      :title="`编辑${ editMode === 1 ? '表头' : '内容' }`"
      @close="showDialog = false"
      :close-on-click-modal="false">
      <el-form :model="form" ref="form" label-position="top" :rules="rules" class="form">
        <el-form-item
          v-for="(item,index) in tableCols"
          :key="index"
          :label="editMode === 1 ? `第${index+1}列` : item.label"
          :prop="`form${index}`"
          style="margin-bottom: 0;">
          <el-input v-if="editMode === 1" v-model="form[`form${index}`]" :disabled="index === tableCols.length - 1" placeholder="请输入内容" :maxlength="15"/>
          <el-input v-else-if="index === tableCols.length - 1" v-model="form[`form${index}`]" v-limit-input-number="{ limitNumber: 2 }" placeholder="请输入内容"/>
          <el-input v-else v-model="form[`form${index}`]" placeholder="请输入内容"/>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button class="bs-btn2" type="primary" @click="showDialog = false">取消</el-button>
        <el-button class="bs-btn" type="primary" @click="handleConfirmEdit">
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { importFile } from "@/api/collection-bill";

const rules = {};
const form = {};
for (let i = 0; i < 10; i++) {
  rules[`form${i}`] = [{ required: true, message: '请输入内容', trigger: 'blur' }];
  form[`form${i}`] = '';
}
export default {
  name: "importCreate",
  data() {
    return {
      tableCols: [],
      tableData: [],
      rules,
      file: null,
      total: 0,
      showDialog: false,
      editMode: 1, // 1表头2表格
      form,
      currIndex: -1,
      loading: false,
    };
  },
  props: {
    templateType: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    templateHref() {
      let href = null;
      switch (this.templateType) {
        case 0:
          href = 'static/自定义收款单.xlsx';
          break;
        case 1:
          href = 'static/教培收款单.xlsx';
          break;
        case 2:
          href = 'static/物业收款单.xlsx';
          break;
        case 3:
          href = 'static/校园征订收款单.xlsx';
          break;
        default:
          break;
      }
      return href;
    },
    downloadName() {
      if (this.templateHref) {
        return this.templateHref.split('/')[1];
      }
      return '';
    },
  },
  methods: {
    init() {
      this.handleReset();
      this.editMode = 1;
      this.currIndex = -1;
    },
    beforeUpload(files) {
      const formData = new FormData();
      this.loading = true;
      formData.append('file', files.raw);
      importFile(formData).then(({ data }) => {
        if (data.error_code === 0) {
          const arr = [...data.data];
          this.tableCols = arr.shift().list.map((item, index) => ({ prop: `col${index}`, label: item }));
          this.tableData = arr.reduce((arr, item) => {
            const newItem = {};
            item.list.forEach((value, index) => { newItem[`col${index}`] = value; });
            arr.push(newItem);
            return arr;
          }, []);
        } else {
          this.handleReset();
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    handleReset() {
      this.tableCols = [];
      this.tableData = [];
      this.$refs.upload.clearFiles();
    },
    handleEditHeader() {
      this.editMode = 1;
      this.tableCols.forEach((item, index) => {
        this.form[`form${index}`] = item.label;
      });
      this.showDialog = true;
    },
    handleEditData(row, index) {
      this.editMode = 2;
      this.currIndex = parseInt(index, 0);
      this.tableCols.forEach((item, index) => {
        this.form[`form${index}`] = row[`col${index}`];
      });
      this.showDialog = true;
    },
    handleConfirmEdit() {
      if (this.editMode === 1) {
        this.tableCols = this.tableCols.map((item, index) => ({ prop: item.prop, label: this.form[`form${index}`] }));
      } else {
        const row = {};
        this.tableCols.forEach((item, index) => {
          row[`col${index}`] = this.form[`form${index}`];
        });
        this.tableData.splice(this.currIndex, 1, row);
      }
      this.showDialog = false;
    },
    getListParam() {
      const exportDtoList = [];
      if (this.tableCols.length) {
        const list = this.tableCols.map(item => (item.label));
        exportDtoList.push({ index: 0, list });
      }
      if (this.tableData.length) {
        this.tableData.forEach((item, index) => {
          exportDtoList.push({ index: index + 1, list: Object.values(item).map(value => (value)) });
        });
      }
      return exportDtoList;
    },
  },
};
</script>

<style scoped lang="scss">
.import-wrapper {
  .sub-title {
    margin-bottom: 20px;
    font-size: 18px;
    font-weight: bold;
    color: #303133;
  }

  .empty-view {
    padding-top: 80px;
    padding-bottom: 46px;
  }

  .upload-btn {
    width: 136px;
    height: 50px;
    margin-bottom: 30px;
    color: #008cff;
    cursor: pointer;
    border: 2px solid #008cff;
    border-radius: 4px;

    .icon {
      width: 20px;
      height: 20px;
      margin-right: 6px;
    }
  }

  .table-top {
    margin-bottom: 30px;
  }

  .pagination {
    margin-top: 20px;
  }

  .desc {
    margin-bottom: 14px;
    font-size: 14px;
    color: #909399;
  }

  .warning {
    font-size: 14px;
    color: #f56c6c;
  }

  .clear-btn {
    color: #008cff;
    background-color: #fff;
    border: 1px solid #008cff;
  }

  .green {
    color: #00be95;
  }

  .ok-icon {
    width: 14px;
    height: 14px;
    margin-right: 4px;
  }

  .mb0 {
    margin-bottom: 0;
  }

  .edit-btn {
    color: #008cff;
  }

  .link {
    color: #008cff;
    text-decoration: underline;
  }

  .form {
    height: 70vh;
    padding-right: 10px;
    overflow: auto;

    .el-form-item {
      margin-bottom: 10px !important;
    }

    /deep/ label {
      padding: 0 !important;
    }
  }
}
</style>
